import { render, staticRenderFns } from "./TraditionalChannelTableWidget.vue?vue&type=template&id=6792b5e3&scoped=true"
import script from "./TraditionalChannelTableWidget.vue?vue&type=script&lang=ts"
export * from "./TraditionalChannelTableWidget.vue?vue&type=script&lang=ts"
import style0 from "./TraditionalChannelTableWidget.vue?vue&type=style&index=0&id=6792b5e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6792b5e3",
  null
  
)

export default component.exports